import React from 'react'
import {
  IonGrid,
  IonRow
} from '@ionic/react'
import CategorySquaredCard from '../CategorySquaredCard'
import { radioSections } from '../../../config/radioCategories'
import './styles.scss'

const CategoryReel = props => {
  return (
    <section className='categories-reel'>
      <IonGrid>
        <IonRow>
          <CategorySquaredCard category={radioSections.podcast} />
          {radioSections &&
            radioSections.radio.categories.detail.map((category) => (
              <CategorySquaredCard key={category.id_category} category={category} />
            ))}
        </IonRow>
      </IonGrid>
    </section>
  )
}

export default CategoryReel
